import { observer } from "mobx-react-lite";
import { FC } from "react";

interface RequireAdminAuthOutletProps {}

export const RequireAdminAuthOutlet: FC<RequireAdminAuthOutletProps> = observer(() => {
  /** @todo - Implement this. */
  return null;
});
